// Хуки для работы с формой Form2

import { useEffect, useCallback } from 'react';
import { validatePositiveZapas, isProtectiveForestsCnl, isNonForestLandCategory, isForestCoveredLandCategory } from './utils';

// Хук для валидации формы
export const useFormValidation = (
  formData,
  displayData,
  setLocalFormData,
  setFormData,
  getCombinedYarusy,
  hasValidationErrors,
  setHasValidationErrors,
  handbooks
) => {
  useEffect(() => {
    if (formData) {
      const requiredFields = [
        'cnl',           // Целевое назначение лесов
        'glu',           // Год лесоустройства
        'katzem'         // Категория земель
        // 'gporoda' исключена: заполняется автоматически (первая порода первого яруса)
      ];
      if (isForestCoveredLandCategory(displayData.katzem)) {
        requiredFields.push('bonitet');
      }
      // П. 2.8: «Категория защитных лесов» обязательна, только если целевое
      // назначение лесов выбрано как «Защитные леса».
      if (isProtectiveForestsCnl(displayData.cnl, handbooks)) {
        requiredFields.push('kzl');
      }

      // Проверяем обязательные поля ярусов (исключаем sostav, так как он заполняется через модальное окно, и zapassir, так как он расчетный).
      // При категории земель, отличной от «покрытые лесной растительностью»,
      // таблица ярусов необязательна целиком.
      const tiersOptional = isNonForestLandCategory(displayData.katzem, handbooks);
      const yarusyErrors = !tiersOptional && getCombinedYarusy().some(yarus =>
        !yarus.yarus || !yarus.polnota ||
        !validatePositiveZapas(yarus.zapassirga) ||
        !yarus.zapassuh || !yarus.zapasred ||
        !yarus.zapased || !yarus.zapaszahl ||
        !yarus.zapaszahllik
      );
      
      const emptyFields = requiredFields.filter(field => {
        const value = displayData[field];
        return !value || value === '';
      });

      const landUnset =
        displayData.landAvailability !== true &&
        displayData.landAvailability !== false;

      const hasErrors = emptyFields.length > 0 || yarusyErrors || landUnset;
      
      // Обновляем только если состояние изменилось
      if (hasValidationErrors !== hasErrors || displayData.form2ValidationErrors !== hasErrors) {
        setHasValidationErrors(hasErrors);
        
        // Обновляем formData с информацией о валидации
        const newData = {
          ...displayData,
          form2ValidationErrors: hasErrors
        };
        setLocalFormData(newData);
        if (setFormData) {
          setFormData(newData);
        }
      }
    }
  }, [formData, hasValidationErrors, setFormData, getCombinedYarusy, displayData, setLocalFormData, handbooks]);
};

// Функция для очистки данных таблицы
export const useClearTableData = (displayData, setLocalFormData, setFormData, yarusy, setYarusy, yarusyDependent, setYarusyDependent) => {
  const clearTableData = useCallback((tableType) => {
    if (tableType === 'info') {
      // Очищаем только данные информации
      const newData = {
        ...displayData,
        cnl: '',
        kzl: '',
        proishozdenie: '',
        ozu: '',
        arenda: '',
        vidarenda: '',
        oopt: '',
        noopt: '',
        glu: '',
        itaks2: '',
        landAvailability: null
      };
      setLocalFormData(newData);
      if (setFormData) {
        setFormData(newData);
      }
    } else if (tableType === 'characteristics') {
      // Очищаем только данные характеристики насаждения
      const newData = {
        ...displayData,
        katzem: '',
        gporoda: '',
        bonitet: '',
        tiplesa: '',
        tlu: ''
      };
      setLocalFormData(newData);
      if (setFormData) {
        setFormData(newData);
      }
    } else if (tableType === 'yarusy') {
      // Очищаем независимые данные ярусов
      const emptyYarus = {
        id: 1,
        yarus: '1',
        sostav: ''
      };
      setYarusy([emptyYarus]);
      
      // Очищаем зависимые данные ярусов
      const emptyYarusDependent = {
        id: 1,
        yarus: '1',
        visota: '',
        klvozr: '',
        grvozr: '',
        polnota: '',
        zapassirga: '',
        zapassir: '',
        zapassuh: '',
        zapasred: '',
        zapased: '',
        zapaszahl: '',
        zapaszahllik: ''
      };
      setYarusyDependent([emptyYarusDependent]);
    }
  }, [displayData, setLocalFormData, setFormData, yarusy, setYarusy, yarusyDependent, setYarusyDependent]);

  return clearTableData;
};

